const $inject = [];

const hotelTagsService = function () {
  let service = {};

  service.get = function get() {
    return require("json!../static/hotel-tags.json");
  };

  return service;
};

hotelTagsService.$inject = $inject;

export default hotelTagsService;


// WEBPACK FOOTER //
// ./src/services/hotelTagService.js